import { Rule } from 'components/core-v2/atoms'
import { Tabs } from 'components/core-v2/molecules'
import { useState } from 'react'

import { BaseModalProps, Modal } from '../modal'
import classes from './index.module.scss'

export const LearnMoreNoteApprovalModal = ({ isOpen, onClose }: BaseModalProps) => {
  const [tab, setTab] = useState<'top-up' | 'withdraw'>('top-up')

  return (
    <Modal.Wrapper
      aria-labelledby="learn-more-modal"
      className={classes.root}
      isOpen={isOpen}
      width="lg"
      onClose={onClose}
    >
      <Modal.Header id="learn-more-modal" onClose={onClose}>
        Learn more about the note approval process
      </Modal.Header>
      <Modal.Body>
        <Tabs.List>
          <Tabs.Tab isSelected={tab === 'top-up'} value="top-up" onClick={() => setTab('top-up')}>
            Top up
          </Tabs.Tab>
          <Tabs.Tab
            isSelected={tab === 'withdraw'}
            value="withdraw"
            onClick={() => setTab('withdraw')}
          >
            Withdrawal
          </Tabs.Tab>
        </Tabs.List>
        <Rule className="mb-8" />
        {tab === 'top-up' && (
          <Tabs.Panel value="top-up">
            <ol>
              <li>
                <span>1. Submitting</span>
                <p>
                  The note is submitted to the approval process by the user. No changes can be made
                  by the user after the note is submitted.{' '}
                </p>
              </li>
              <li>
                <span>2. Approval</span>
                <p>At this step, the note will be formally approved or rejected by the Bank. </p>
              </li>
              <li>
                <span>3. Commitment</span>
                <p>
                  Once the note has been approved by the Bank, the Client now has 5 business days to
                  formally commit to the note.{' '}
                </p>
              </li>
              <li>
                <span>4. Settlement</span>
                <p>
                  If the note involves new investment being added, then this should be settled once
                  the note has been committed to.{' '}
                </p>
              </li>
              <li>
                <span>5. Activation</span>
                <p>
                  The Bank will then activate the note, which will trigger the necessary orders and
                  changes to be made on all the relevant trades for the note.{' '}
                </p>
              </li>
              <li>
                <span>6. Activated (live)</span>
                <p>
                  All trades within the note have now been activated and can be viewed in the
                  Reporting section of the platform.{' '}
                </p>
              </li>
            </ol>
          </Tabs.Panel>
        )}
        {tab === 'withdraw' && (
          <Tabs.Panel value="withdraw">
            <ol>
              <li>
                <span>1. Submitting</span>
                <p>
                  The note is submitted to the approval process by the user. No changes can be made
                  by the user after the note is submitted.{' '}
                </p>
              </li>
              <li>
                <span>2. Commitment</span>
                <p>
                  Once the note has been approved by the Bank, the Client now has 5 business days to
                  formally commit to the note.{' '}
                </p>
              </li>
              <li>
                <span>3. Activated (live)</span>
                <p>
                  All trades within the note have now been activated and can be viewed in the
                  Reporting section of the platform.{' '}
                </p>
              </li>
            </ol>
          </Tabs.Panel>
        )}
      </Modal.Body>
    </Modal.Wrapper>
  )
}
